<template>
  <div>
    <b>{{ notification.cause.entityName }}</b>
    {{ $t(this.messageBody) }}
    <i>{{ notification.details.documentTitle }}</i>
  </div>
</template>
<script>
export default {
  name: 'AnalysisNotificationCardContent',
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  computed: {
    messageBody() {
      if (this.notification.details.type === 'shared') {
        return 'views.notifications.analysisShared.body';
      }

      return 'views.notifications.analysisModified.body';
    },
  },
};
</script>
<style scoped>
</style>
